function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#EFD1FA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1842 18.4737L19.9736 9L25.7631 18.4737H14.1842ZM22.0052 16.3684L19.9736 13.0421L17.9315 16.3684H22.0052ZM25.7632 20.5789C23.1422 20.5789 21.0264 22.6947 21.0264 25.3158C21.0264 27.9368 23.1422 30.0526 25.7632 30.0526C28.3843 30.0526 30.5001 27.9368 30.5001 25.3158C30.5001 22.6947 28.3843 20.5789 25.7632 20.5789ZM23.1316 25.3158C23.1316 26.7684 24.3105 27.9474 25.7632 27.9474C27.2158 27.9474 28.3947 26.7684 28.3947 25.3158C28.3947 23.8632 27.2158 22.6842 25.7632 22.6842C24.3105 22.6842 23.1316 23.8632 23.1316 25.3158ZM10.5 29.5263H18.9211V21.1053H10.5V29.5263ZM16.8157 23.2105H12.6052V27.4211H16.8157V23.2105Z",
  fill: "#121221"
});

function SvgMiscellaneous(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneous);
export default __webpack_public_path__ + "static/media/Miscellaneous.ce81cb0b.svg";
export { ForwardRef as ReactComponent };